/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListStaffQueryResponse, ListStaffPathParams, ListStaff400, ListStaff401, ListStaff403, ListStaff404, ListStaff409, ListStaff500 } from "../../types/staffController/ListStaff.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listStaff } from "../../client/staffController/listStaff.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listStaffQueryKey = (organizationId: ListStaffPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/staff', params: {organizationId:organizationId} }] as const

export type ListStaffQueryKey = ReturnType<typeof listStaffQueryKey>

export function listStaffQueryOptions(organizationId: ListStaffPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listStaffQueryKey(organizationId)
        return queryOptions<ListStaffQueryResponse, ResponseErrorConfig<ListStaff400 | ListStaff401 | ListStaff403 | ListStaff404 | ListStaff409 | ListStaff500>, ListStaffQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listStaff(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List staff members
 * {@link /api/organizations/:organizationId/staff}
 */
export function useListStaff<TData = ListStaffQueryResponse, TQueryData = ListStaffQueryResponse, TQueryKey extends QueryKey = ListStaffQueryKey>(organizationId: ListStaffPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ListStaffQueryResponse, ResponseErrorConfig<ListStaff400 | ListStaff401 | ListStaff403 | ListStaff404 | ListStaff409 | ListStaff500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listStaffQueryKey(organizationId)
         

         const query = useQuery({
          ...listStaffQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListStaff400 | ListStaff401 | ListStaff403 | ListStaff404 | ListStaff409 | ListStaff500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}